import { Suspense, lazy } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

const TableControlLazy = lazy(() => import("./TableControl"));
export function TableControl(props) {
  return _jsx(Suspense, {
    children: _jsx(TableControlLazy, Object.assign({}, props)),
  });
}
export * from "./TableControlLayoutProps";
export * from "./useTableControlUiOptions";
export * from "./useTableControlStateDefaults";
export * from "./useTableControlReadonlyOptions";
